'use client';
import classes from './BetterForPlanetBadge.module.css';
import { useEffect, useState } from 'react';

const BetterForPlanetBadge = ({ deviceWidth }) => {
	const [innerWidth, setInnerWidth] = useState(
		deviceWidth ? deviceWidth : 1280
	);

	useEffect(() => {
		setInnerWidth(window.innerWidth);
	}, []);
	return (
		<>
			{innerWidth < 600 && (
				<section className={classes.badge}>
					<div className={classes.badgeIcon}>
						<img
							className={classes.img}
							src="https://ik.imagekit.io/kuj9zqlrx0or/Static/tree-sustainable.png?tr=w-100,h-100"
							alt="Buy preloved furniture, second hand furniture, 80% off retail"
						/>
					</div>
					<section className={classes.badgeTextContainer}>
						<h5 className={classes.badgeTitle}>
							More sustainable than buying new
						</h5>
						<div className={classes.badgeText}>
							Choosing pre-loved is choosing planet first{' '}
						</div>
					</section>
				</section>
			)}
		</>
	);
};
export default BetterForPlanetBadge;
